export enum WebApiName {
    Accelerometer = 'accelerometer',
    Accessibility = 'accessibility',
    AmbientLightSensor = 'ambient-light-sensor',
    BackgroundSync = 'background-sync',
    Camera = 'camera',
    ClipboardRead = 'clipboard-read',
    ClipboardWrite = 'clipboard-write',
    Geolocation = 'geolocation',
    Magnetometer = 'magnetometer',
    Microphone = 'microphone',
    Midi = 'midi',
    Notifications = 'notifications',
    PaymentHandler = 'payment-handler',
    Permissions = 'permissions',
    PersistentStorage = 'persistent-storage',
    Push = 'push',
}
